import { Injectable } from '@angular/core';
import { FormbirdInjectorService, SearchService } from 'formbird-services';
import {sclHandlebars} from 'formbird-sc-shared';
import {SclMapConstantService} from './scl-map-constant.service';
import {SclUtilMapService} from './scl-util-map.service';
import { AddressDetails } from './AddressDetails';
const sclMapConstant = SclMapConstantService;
const sclUtilMapService = new SclUtilMapService();


@Injectable({
  providedIn: 'root'
})
export class SclMapGeoDocService {
  private searchClientService: any;

  constructor(private formbirdInjectorService: FormbirdInjectorService) {
    this.searchClientService = this.formbirdInjectorService.get('SearchClientService')
  }

  autocompleteBox;
  waitTime = 5000; // miliseconds
  radius = 50;
  initObj;
  preText = '';
  autocompleteStreet;
  state; country;
  filter = ''; geoJsonField; lookUpCb = null; lookUpCbErr = null;
  lookUpCbSelectOption = null; lookUpCbRemoveStreet = null;
  dexieSearchFilter = null;
  queryName = null;
  relatedDocument = null;

  setupReverse(geo){
    if (geo.radius) {
      this.radius = geo.radius;
    }
  }

  buildSearchOption(filter) {
    const options: any = {
      page: 0,
      pageSize: this.initObj.pageSize,
      document: this.initObj.document,
      filter: filter,
      searchOptions: null,
      queryName: null,
      dataSource: null,
      sourceFilter: [this.geoJsonField , 'documentId', 'systemHeader.summaryName']
    };
    if (this.queryName) {
      options.dataSource =  this.searchClientService.getDefaultSearchProvider(this);
      options.queryName = this.queryName;
      options.searchOfflineOnly = this.initObj?.assetField?.searchOptions?.searchOfflineOnly;
    }
    if (this.relatedDocument) {
      for (const field in this.relatedDocument) {
        if (this.relatedDocument.hasOwnProperty(field) &&  options.sourceFilter.indexOf(field) < 0) {
          options.sourceFilter.push(this.relatedDocument[field]);
        }
      }
    }
    return options;
  }

  reverse( coor, cb, cbErr, cbTimeout) {
    if (this.lookUpCb == null) { this.lookUpCb = this.initObj.lookUpCb; }
    if (this.lookUpCbErr == null) { this.lookUpCbErr = this.initObj.lookUpCbErr; }
    if (this.lookUpCbSelectOption == null) { this.lookUpCbSelectOption = this.initObj.lookUpCbSelectOption; }
    if (this.lookUpCbRemoveStreet == null) { this.lookUpCbRemoveStreet = this.initObj.lookUpCbRemoveStreet; }
    if (this.initObj.clearStreetSearchTextBox && typeof this.initObj.clearStreetSearchTextBox === 'function') {
      this.initObj.clearStreetSearchTextBox(null);
    }

    const lat = coor[1]; const lon = coor[0]; let radius = coor[2];
    const coorNext = coor;
    if (this.filter.trim().length > 0) {
      const newFilter = sclHandlebars.processHandlebars(this.filter, null, null, null, this.initObj.contextParams);
      let hasBoundingBox = true;
      if (this.initObj?.assetField?.noBoundingBox) {
        hasBoundingBox = !this.initObj.assetField.noBoundingBox;
      }
      const filter = sclUtilMapService.getQueryGeo(coor, coorNext, newFilter, this.geoJsonField
        , hasBoundingBox);

      const options = this.buildSearchOption(filter);

      this.searchClientService.search(options).then(data => {
          if (data && data.data && data.data.hits && data.data.hits.hits && data.data.hits.hits.length > 0) {
            const customData = data.data.hits.hits;
            const suggestions = customData[0]._source; // get the first item

            const streetData: any = new AddressDetails();
            let sugLon = lon;
            let sugLat = lat;


            if (suggestions && suggestions[this.geoJsonField] && suggestions[this.geoJsonField].features
                && suggestions[this.geoJsonField].features.length == 1) {
              if (suggestions[this.geoJsonField].features[0].properties) {
                const address = suggestions[this.geoJsonField].features[0].properties;

                streetData.properties.streetNo = address.streetNo;
                streetData.properties.street = address.street;
                streetData.properties.suburb = address.suburb;
                streetData.properties.postcode = address.postcode;
                streetData.properties.country = address.country;
                streetData.properties.state = address.state;
              }
              if (suggestions[this.geoJsonField].features[0].geometry && suggestions[this.geoJsonField].features[0].coordinates
                && suggestions[this.geoJsonField].features[0].coordinates.length == 2) {
                  sugLon = suggestions[this.geoJsonField].features[0].coordinates[0];
                  sugLat = suggestions[this.geoJsonField].features[0].coordinates[1];
              }
              streetData.geometry.coordinates[0] = lon; // lon
              streetData.geometry.coordinates[1] = lat; // lat

              streetData.objRelated = this.getRelatedField(suggestions);
              if (cb && typeof cb === 'function') {
                cb(streetData, { lat: sugLat, lng: sugLon });
              }

            } else {
              if (cbErr && typeof cbErr === 'function') {
                cbErr('There has no data');
              }
            }
          } else {
            if (cbErr && typeof cbErr === 'function') {
              cbErr('There has no data');
            }
          }
        },
        err => {
          if (err.status === -1) {
            if (cbTimeout && typeof cbTimeout === 'function') {
              cbTimeout();
            }
          } else {
            // logger.info(err);
            if (cbErr && typeof cbErr === 'function') {
              cbErr('DOC reverse address Error ');
            }
          }

        }
      );

    } else {
      console.log('cant not run reverse function because filter is empty or is NULL');
    }
  }

  lookUp(params, cb, cbErr, cbSelectOption, cbRemoveStreet, cbTimeout, customData? ) {
    // cb, cbErr, cbSelectOption, cbRemoveStreet
    this.lookUpCb = cb; this.lookUpCbErr = cbErr; this.lookUpCbSelectOption = cbSelectOption; this.lookUpCbRemoveStreet = cbRemoveStreet;
    if (params == null || params.length < 1) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('params is invalid, [0] : autocompleteBox');
      }
      return;
    }
    if (this.autocompleteBox == null) {
      this.autocompleteBox = params[0];
    }


    if (params.length > 1) {
      this.search(params[1], cb, cbErr, cbTimeout);
    }

  }

  removeLookUp() {
      const id = this.initObj.keyName + 'MapGeoDoc';
      const elem = document.getElementById(id);
      if (elem) {
        elem.remove();
      }

      this.autocompleteBox = null;
  }

  removeStreet(cb) {
      if (this.autocompleteStreet == null) {
        this.autocompleteStreet = document.getElementById(this.initObj.keyName + 'autocomplete');
      }
      if (this.autocompleteStreet == null) {
        if (cb && typeof cb === 'function') {
          cb();
        }
        return;
      }
      this.autocompleteStreet.value = '';

      if (cb && typeof cb === 'function') {
        cb();
      }
  }
  getObjectNotWildcardSummaryName(mustObject) {
    const mustSelected = [];
    mustObject.map((key, index) => {
      let isFoundSummaryName = false;
      if (key.wildcard) {
        for (const sss in key.wildcard) {
          if (sss === 'systemHeader.summaryName.lcase') {
            isFoundSummaryName = true;
          } else {
            isFoundSummaryName = false;
          }
        }
      } else {
        isFoundSummaryName = false;
      }
      if (!isFoundSummaryName) {
        mustSelected.push(mustObject[index]);
      }
    });
    return mustSelected;
  }
  search(sPartialDocName, cb, cbErr, cbTimeout) {
    if (sPartialDocName == null) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('Text is NULL');
      }
      return;
    }

    const newText = sPartialDocName.trim();
    if (newText === this.preText) {
      if (cb && typeof cb === 'function') {
        cb([]);
      }
      return;
    }

    this.preText = newText;

    if (newText.length < 3) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('Text is less than 3 charcters');
      }
      return;
    }
    let filter = sclHandlebars.processHandlebars(this.filter, null
      , null, null, this.initObj.contextParams);
    if (typeof filter === 'string') {
      filter = filter.replace(/'/g, '"');
    }
    // begin 15263
    const filterObj = JSON.parse(filter);
    if (filterObj.query.bool.should === undefined) {
      filterObj.query.bool.should = [];
    }
    if (filterObj.query.bool.must instanceof Object && filterObj.query.bool.must.constructor === Object){
      const objMust = filterObj.query.bool.must;
      filterObj.query.bool.must = [];
      filterObj.query.bool.must.push(objMust);
    } else {
      if (filterObj.query.bool.must === undefined) {
          filterObj.query.bool.must = [];
      }
    }
    filterObj.query.bool.must = this.getObjectNotWildcardSummaryName(filterObj.query.bool.must);
    filterObj.query.bool.must.push({wildcard: {'systemHeader.summaryName.lcase': '*' + newText.toLowerCase() + '*'}});
    filter = JSON.stringify(filterObj);

    const options = this.buildSearchOption(filter);

    this.searchClientService.search(options).then(data => {
        if (data && data.data && data.data.hits && data.data.hits.hits && data.data.hits.hits.length > 0) {
          const customData = data.data.hits.hits;
          this.lookUpResultDataCb(customData, cb);
        } else {
          if (cbErr && typeof cbErr === 'function') {
            cbErr('DOC address lookup Error ');
          }
        }
      },
      err => {
        if (err.status === -1) {
          if (cbTimeout && typeof cbTimeout === 'function') {
            cbTimeout();
          }
        } else {
          if (cbErr && typeof cbErr === 'function') {
            cbErr('DOC address lookup Error ');
          }
        }

      }
    );
  }
  lookUpResultDataCb(customData, cb) {
    const results = [];

    for (let i = 0; i < customData.length; i++) {
      const item = customData[i]._source;
      const sugg: any = {};
      sugg.street = item.systemHeader.summaryName;
      sugg.address = item;
      if (item[this.geoJsonField] && item[this.geoJsonField].features && item[this.geoJsonField].features.length > 0
        && item[this.geoJsonField].features[0].geometry && item[this.geoJsonField].features[0].geometry.coordinates) {
          const lat = item[this.geoJsonField].features[0].geometry.coordinates[1];
          const lng = item[this.geoJsonField].features[0].geometry.coordinates[0];
          sugg.coordinates = {
            "Latitude": lat,
            "Longitude": lng
          };
      } else {
        console.log(sugg.street + ' - ' + item.documentId + ' does not have geometry data');
      }
      results.push(sugg);
    }

    if (cb && typeof cb === 'function') {
      cb(results);
    }
  }

  selectionOption(tpl, model, cb) {
    const data = tpl.address; const coordinates = tpl.coordinates;
    const obj: any = new AddressDetails();

    if (data[this.geoJsonField] && data[this.geoJsonField].features && data[this.geoJsonField].features.length > 0
       && data[this.geoJsonField].features[0].properties) {
        const address = data[this.geoJsonField].features[0].properties;

        obj.properties.streetNo = address.streetNo;
        obj.properties.street = address.street;
        obj.properties.suburb = address.suburb;
        obj.properties.postcode = address.postcode;
        obj.properties.country = address.country;
        obj.properties.state = address.state;
    }

    if (coordinates) {
      const lat = parseFloat(coordinates.Latitude);
      const lon = parseFloat(coordinates.Longitude);
      obj.geometry.coordinates[0] = lon;
      obj.geometry.coordinates[1] = lat;
    }
    obj.objRelated = this.getRelatedField(data);

    if (this.lookUpCbSelectOption && typeof this.lookUpCbSelectOption === 'function') {
      this.lookUpCbSelectOption(obj);
    }

  }

  getLinkOptions( link) {
    if (this.state) { link += ' ' + this.state; }
    if (this.country) { link += ' ' + this.country; }

    return link;
  }

  getRelatedField(addressData) {
    let relatedObj = null;
    if (this.relatedDocument) {
      for (const field in this.relatedDocument) {
        if (this.relatedDocument.hasOwnProperty(field)) {
          const dataField = this.relatedDocument[field];
          const value = addressData[dataField];
          if (value) {
            if (relatedObj == null) {
              relatedObj = {};
            }
            relatedObj[field] = value;
          }
        }
      }
    }
    return relatedObj;
  }
}
